const ConfirmedSequence = 2;
const PreparingSequence = 3;
const DeliveredSequence = 5;

function parseStepCode(step, prepaid, cancelled, paid) {
  if (cancelled) {
    return 'cancelled';
  }

  if (prepaid && step.sequence < PreparingSequence) {
    if (paid) {
      return 'ordered';
    }

    return 'added';
  }

  return step.code;
}

export {
  parseStepCode,
  ConfirmedSequence,
  PreparingSequence,
  DeliveredSequence,
};
